import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyboard1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconKeyboard1"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3V22H21V3H3ZM6.5 5H5V20H8V14H6.5V5ZM10 20H14V14H12.5V5H11.5V14H10V20ZM17.5 5V14H16V20H19V5H17.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconKeyboard1;
